import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ourVisionStyle from "./ourVisionStyle";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ourVisionImg from "../../../../assets/images/ourVision.jpg";
import { scrollToProjectEnd } from "../../../../utils/scrollToProjectEnd"; // Import smooth scrolling function

const OurVision = ({ onClose }) => {
  const classes = ourVisionStyle();

  return (
    <Box className={`${classes.detailsContainer} ${classes.fadeIn}`}>
      <Box className={classes.detailsSection}>
        <Typography className={classes.header}>
          Reimagining Paketposthalle
        </Typography>

        {/* First Row: Text Left, Image Right */}
        <Box className={classes.detailsRow}>
          <Box className={classes.detailsText}>
            <Typography variant="body1" className={classes.paragraph}>
                Our team has refined Herzog & de Meuron’s master plan by preserving Munich’s skyline through a more harmonious approach—reducing 
                the tower heights to 100 meters while maintaining Paketposthalle’s historic role as an open and accessible public space.
            </Typography>

            <Typography variant="body1" className={classes.paragraph}>
              Beyond height adjustments, our site plan and building placement have been optimized 
              through environmental analysis, considering shadow impact, visibility, and sustainability 
              to enhance urban livability. The new design introduces two 100-meter-high mixed-use towers 
              with a spacious commercial base.
            </Typography>
            <Typography variant="body1" className={classes.paragraph}>
              To create a balanced and inclusive urban environment, two residential buildings—one in the north and one in the south—will provide social housing close to the city’s active core. 
              Our vision is to seamlessly integrate Paketposthalle’s historical essence into a dynamic, vibrant public space, ensuring a sustainable and people-centered future for this landmark.
            </Typography>
          </Box>

          <Box className={classes.imageContainer}>
            <Box className={classes.detailsImage} style={{ backgroundImage: `url(${ourVisionImg})` }} />
            <Typography variant="caption" className={classes.imageCopyright}>
              © Image by Veras Ai
            </Typography>
          </Box>
        </Box>

        {/* Collapse Button */}
        <Button className={classes.collapseButton} onClick={() => scrollToProjectEnd(onClose)}>
          <ExpandLessIcon />
        </Button>
      </Box>
    </Box>
  );
};

export default OurVision;
